<template>
    <div v-if="isLoaded">
        <b-row align-h="between" style="text-align: center">
            <b-col cols="6" class="mb-4" style="display: flex; justify-content: flex-start; height: 40px;">
                <div @click="routeToDashboard(route.params.site_id, year)" style="font-weight: bold; font-size: 1.2em; align-self: center; cursor: pointer">{{selectedSite.name}}</div>
            </b-col>
            <b-col cols="4" sm="4" md="6" lg="6" xl="5">
                <b-row align-h="end">
                    <year-select @onchange="onYearChange"/>
                    <site-multi-select
                        :selectedSiteId="selectedSite.id"
                        :givenSites="filteredSites"
                        :allowEmpty="true"
                        @oninput="selectSiteId"/>
                </b-row>
            </b-col>
        </b-row>
        <b-row align-h="between">
            <b-col cols="8" style="font-weight: bold; text-align: start;">{{ $t(tableInfo.info.tableName) + selectedUnit}}</b-col>
        </b-row>
        <b-row align-h="start" class="overflow-auto">
            <vue-table
                :tableName="'data_detail'"
                @applyDataChanges="applyDataChanges"
                @insertItem="insertItem"
                @deleteItemById="deleteItemById"
                :initialData="tableInfo"
                :type="'data'"
                :siteId="this.route.params.site_id"
                :isEditable="this.$store.state.user.permissions.canEditData"
            />
        </b-row>
    </div>
    <div v-else></div>
</template>

<script>
import qs from 'qs';
import moment from 'moment';
import _ from 'lodash';
import VueTable from '../../components/Table.vue';
import Multiselect from 'vue-multiselect';
import SiteMultiSelect from '../../components/SiteMultiSelect';
import YearSelect from '../../components/YearSelect';

export default {
    name: 'data-detail',
    components: {YearSelect, SiteMultiSelect, VueTable, Multiselect},
    props: {
        selectedTag: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isLoaded: false,
            filteredSites: this.$store.state.sites, // Workaround for multi-select plugin
            selectedSite: null,
            selectedUnit: null,
            tableInfo: {
                fields: [],
                items: []
            },
            maxDigitCount: 9,
        };
    },
    methods: {
        onYearChange(newYear) {
            this.$store.state.year = newYear;
            this.$router.push({
                name: 'data-detail',
                params: {site_id: this.route.params.site_id, type_id: this.route.params.type_id},
                query: {year: this.year}
            });
            this.listDataDetails();
        },
        selectSiteId(site) {
            if (!site) {
                this.$router.push({name: 'data-sites'});
            } else {
                this.selectedSite = site;
                this.$store.state.siteId = site ? site.id : null;
                let tags = site.tags;
                // if tags of selected site don't includes previously selected tag, route is changed to summary page (top page).
                if (tags.map(tag => tag.key).indexOf(this.selectedTag) === -1) {
                    this.$emit('changetag', site.id);
                    this.$router.push({
                        name: 'site-data-types',
                        params: {site_id: site.id},
                        query: {year: this.year}
                    });
                } else {
                    this.isLoaded = false;
                    this.$router.push({
                        name: 'data-detail',
                        params: {site_id: site.id, type_id: this.route.params.type_id},
                        query: {year: this.year}
                    });
                    this.listDataDetails();
                }
            }
        },
        isOutOfMaxDigitLength(val){
            if(this.delocalizeValue(_.toString(val),this.locale).split(',')[0].replaceAll('.','').length>this.maxDigitCount){
                return true;
            }
            return false;
        },
        applyDataChanges(item, fields, callback, onWarnCallBack) {
            let updatedItem = {
                id: item.id,
                siteId: this.route.params.site_id,
                typeId: this.route.params.type_id,
                year: this.$store.state.year
            };

            if('cost' in item && this.isOutOfMaxDigitLength(_.get(item, "cost").editedValue)){
                this.$toasted.error(this.$t("cost-out-range"));
                return onWarnCallBack();
            }
            if('value1' in item && this.isOutOfMaxDigitLength(_.get(item, "value1").editedValue)){
                this.$toasted.error(this.$t("value-out-range"));
                return onWarnCallBack();
            }

            fields.forEach(field => {
                if (field.editable) {
                    if (field.type === 'date') {
                        updatedItem[field.key] = moment(item[field.key].editedValue).toDate();
                    } else if (field.type === 'daterange' || field.type === 'text') {
                        updatedItem[field.key] = item[field.key].editedValue;
                    } else if (field.type === 'number' || field.type === 'float') {
                        updatedItem[field.key] = this.delocalizeValue(
                            _.toString(item[field.key].editedValue),
                            this.locale
                        );
                    } else if (field.type === 'file') {
                        updatedItem[field.key] = item[field.key].editedFileId;
                    } else {
                        updatedItem[field.key] = item[field.key].editedValue;
                    }
                }
            });
            // UTC conversion of dates in order to prevent data loss due to UTC time zone difference.

            updatedItem.date[0] = this.createUTCDate(
                updatedItem.date[0].getFullYear(),
                updatedItem.date[0].getMonth(),
                updatedItem.date[0].getDate()
            );
            updatedItem.date[1] = this.createUTCDate(
                updatedItem.date[1].getFullYear(),
                updatedItem.date[1].getMonth(),
                updatedItem.date[1].getDate()
            );
            updatedItem.locale = this.$store.state.locale;
            return this.axios
                .put('/data', updatedItem)
                .then(response => {
                    this.listDataDetails();
                    return callback(response.data);
                })
                .catch(err => {
                    this.$toasted.error(this.$t(err.response.data.message));
                    return onWarnCallBack();
                });
        },
        insertItem(item, callback, onWarnCallBack) {
            let insertedItem = {
                siteId: this.route.params.site_id,
                typeId: this.route.params.type_id,
                year: this.$store.state.year,
                locale: this.$store.state.locale
            };

            if('cost' in item && this.isOutOfMaxDigitLength(_.get(item, "cost").value)){
                this.$toasted.error(this.$t("cost-out-range"));
                return onWarnCallBack();
            }
            if('value1' in item && this.isOutOfMaxDigitLength(_.get(item, "value1").value)){
                this.$toasted.error(this.$t("value-out-range"));
                return onWarnCallBack();
            }

            this.tableInfo.fields.forEach(field => {
                if (field.editable) {
                    if (field.type === 'date') {
                        insertedItem[field.key] = moment(item[field.key].value).toDate();
                    } else if (field.type === 'daterange' || field.type === 'text') {
                        insertedItem[field.key] = item[field.key].value;
                    } else if (field.type === 'number' || field.type === 'float') {
                        if (field.key == 'cost') {
                            // @todo: currency is given as hardcoded here. There is something to do this automaticaly.
                            // But the goal is sending insertedItem.currency with a currency symbol to /data post request.
                            insertedItem.currency =
                                this.$store.state.user.customerId == 2041 ? 'AED' : 'tl';
                        }
                        item[field.key].value = item[field.key].value == null ? '0' : item[field.key].value;
                        insertedItem[field.key] = this.delocalizeValue(
                            item[field.key].value,
                            this.locale
                        );
                    } else if (field.type === 'file') {
                        insertedItem[field.key] = item[field.key].fileId;
                    } else {
                        insertedItem[field.key] = item[field.key].value;
                    }
                }
            });
            // UTC conversion of dates in order to prevent data loss due to UTC time zone difference.
            insertedItem.date[0] = this.createUTCDate(
                insertedItem.date[0].getFullYear(),
                insertedItem.date[0].getMonth(),
                insertedItem.date[0].getDate()
            );
            insertedItem.date[1] = this.createUTCDate(
                insertedItem.date[1].getFullYear(),
                insertedItem.date[1].getMonth(),
                insertedItem.date[1].getDate()
            );

            
            return this.axios
                .post('/data', insertedItem)
                .then(response => {
                    this.listDataDetails();
                    return callback(response.data);
                })
                .catch(err => {
                    this.$toasted.error(this.$t(err.response.data.message));
                    return onWarnCallBack();
                });
        },
        deleteItemById(id) {
            return this.axios.delete(`${this.route.params.site_id}/data/${id}`).catch(() => {
                this.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                this.init();
            });
        },
        listDataDetails() {
            this.$Progress.start();
            return this.axios
                .get(
                    `/data/${this.selectedSite.id}/types/${
                        this.route.params.type_id
                    }?${qs.stringify({year: this.year})}&locale=${this.$store.state.locale}`
                )
                .then(response => {
                    this.tableInfo = {
                        fields: response.data.meta[this.route.params.type_id]
                            ? response.data.meta[this.route.params.type_id].table
                            : [],
                        info: response.data.meta[this.route.params.type_id]
                            ? response.data.meta[this.route.params.type_id].info
                            : {},
                        items: response.data.data[this.route.params.type_id]
                            ? response.data.data[this.route.params.type_id]
                            : [],
                        unitPrice: response.data.unitPrice
                    };
                    this.tableInfo.fields = this.isbId(this.$store.state.user.customerId) ? _.filter(_.cloneDeep(this.tableInfo.fields), o => (o.key !== 'cost')) : this.tableInfo.fields;
                    this.isLoaded = true;
                    this.$Progress.finish();
                    return this.tableInfo;
                });
        },
        init() {
            let dataTypeId = this.route.params.type_id;
            let currentDataType = _.find(this.$store.state.dataTypes, function(o) {
                return o.id == dataTypeId;
            });
            this.selectedUnit =
                ' (' +
                this.$t(_.find(this.$store.state.units, {id: currentDataType.unit_id_1}).name) +
                ')';
            this.listDataDetails();
        }
    },
    created() {
        this.selectedSite = _.find(this.sites, {id: Number(this.route.params.site_id)});
        this.$store.state.year = this.route.query.year
            ? Number(this.route.query.year)
            : this.$store.state.year;
        this.init();
    }
};
</script>

<style lang="scss" scoped>
</style>

<i18n src="../../i18n/common.json"></i18n>
<i18n>
    {
        "tr": {
            "cost-out-range": "Maksimum 9 basamaklı veri girişi yapabilirsiniz. Daha küçük sayılar ile giriş yapmayı deneyiniz.",
            "value-out-range": "Maksimum 9 basamaklı veri girişi yapabilirsiniz. Daha küçük sayılar ile giriş yapmayı deneyiniz.",
            "Evsel Atık": "Evsel Atık"
        },
        "en": {
            "cost-out-range": "You can enter a maximum of 9 digits. Try to enter smaller data.",
            "value-out-range": "You can enter a maximum of 9 digits. Try to enter smaller data.",
            "Evsel Atık": "Domestic Waste"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Data/Detail.vue